<template>
  <div class="content-tab igmp-statistic">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <!-- <scrollbar ref="scrollbar" class="scrollbar-body"> -->
        <!-- <div class="content-item">
          <div class="content-body-header">{{$t('igmp.statistics')}}
          </div>
          <div class="content-item status" v-for="(item, index) in statusObj" :key="index">
            <div class="title">{{$t('mactable.vlanId')}}<span>{{item.key}}</span></div>
            <table class="table-row">
              <tr>
                <td>
                  <div class="title">{{$t('igmp.querierStatus')}}</div>
                  <div class="dynamic-color value">{{(item.val.QuerierStatus === 'active')? $t('port.enabled') : $t('port.disabled')}}</div>
                </td>
                <td>
                  <div class="title">{{$t('igmp.querierTrans')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterTxGeneralQuery}}</div>
                </td>
                <td>
                  <div class="title">{{$t('igmp.querierReceived')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterRxGeneralQuery}}</div>
                </td>
                <td>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="title">{{$t('igmp.receivedV1')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterRxV1Join}}</div>
                </td>
                <td>
                  <div class="title">{{$t('igmp.receivedV2')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterRxV2Join}}</div>
                </td>
                <td>
                  <div class="title">{{$t('igmp.receivedV3')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterRxV3Join}}</div>
                </td>
                <td>
                  <div class="title">{{$t('igmp.receivedV2Leave')}}</div>
                  <div class="dynamic-color value">{{item.val.CounterRxV2Leave}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div> -->
      <div class="content-item">
        <div class="content-body-header">{{$t('igmp.groupInfo')}}</div>
        <div class="group-table" v-if="!isEmpty">
            <fixed-table ref="groupTable" :data="groupObj" :use-page="false" :header-height="40">
                <div class="right-header" slot="right-header">
                  <column style="width: 8%;">{{$t('vlan.vlanId')}}</column>
                  <column style="width: 16%;">{{$t('group')}}</column>
                  <column class="portNo" v-for="num in portNumber" :key="num" :style="{ width: (40/ portNumber)+'%' }">{{num}}</column>
                  <column class="portNo" :title="$t('lag.groupName') + num" v-for="num in lagGroupMap.size" :key="num+lagStartNum" :style="{width: (36 / lagGroupMap.size )+'%'}">{{$t('lag.groupName') + ' ' + num}}</column>
                </div>
                <template slot="rows" slot-scope="props">
                    <div class="link-row">
                        <row class="right" :props="props">
                          <div class="data" style="width: 8%;">{{props.data.key[0]}}</div>
                          <div class="data" style="width: 16%;">{{props.data.key[1]}}</div>
                          <div class="data portNo" :class="{ isOdd: getOdd(index)}" :style="{ width: (40/ portNumber)+'%' }" v-for="index in portNumber" :key="index">
                            <div class="q-icon icon-tick" v-if="getPortMembers(props.data.val.MemberPorts, index)"></div>
                          </div>
                          <div class="data portNo" :class="{ isOdd: getOdd(index + isPortOdd)}" :style="{width: (36 / lagGroupMap.size )+'%'}" v-for="index in lagGroupMap.size" :key="index+lagStartNum">
                            <div v-if="getPortMembers(props.data.val.MemberPorts, index + lagStartNum)" class="q-icon icon-tick"></div>
                          </div>
                        </row>
                    </div>
                </template>
            </fixed-table>
        </div>
        <div class="content-item empty" v-else>
          <nodata/>
          <div>{{$t('empty')}}</div>
        </div>
      </div>
      <!-- </scrollbar> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import nodata from '../assets/svg/no_data.svg'
export default {
  name: 'IgmpStatistic',
  components: {
    fixedTable,
    row,
    column,
    nodata
  },
  data () {
    return {
      statusObj: null,
      groupObj: null,
      isShowLoading: true,
      isEmpty: null,
      groupInterval: null,
      isPortOdd: 0
    }
  },
  created: async function () {
    this.getIGMPstatus()
    this.isPortOdd = (this.getOdd(this.portNumber)) ? 1 : 0
  },
  beforeDestroy () {
    clearInterval(this.groupInterval)
  },
  watch: {
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.groupInterval)
          this.groupInterval = null
        }
      },
      immediate: true,
      deep: true
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.groupInterval)
        this.groupInterval = null
      }
    }
  },
  methods: {
    ...mapActions(['getIGMPStatistics', 'getIGMPgroups', 'getIGMPSnooping']),
    getIGMPstatus: function () {
      this.getIGMPSnooping()
        .then((res) => {
          if (res.error_code === 200 && res.result) {
            this.snoopObj = res.result
            if (this.snoopObj.AdminState) {
              this.getData()
            } else {
              this.isEmpty = true
              this.isShowLoading = false
            }
          }
        }).catch((err) => {
          this.$log.error(err)
          this.isShowLoading = false
        })
    },
    getData: function () {
      let me = this
      me.isShowLoading = true
      this.groupInterval = setInterval(() => {
        try {
          if (me.showFullLoading) {
            clearInterval(me.groupInterval)
            me.groupInterval = null
          } else {
            me.getIGMPStatistics()
              .then(res => {
                me.statusObj = res.result
              }).catch((err) => {
                this.$log.error(err)
                clearInterval(this.groupInterval)
                this.isShowLoading = false
              })
            me.getIGMPgroups()
              .then(res => {
                me.groupObj = res.result
                if (me.groupObj && me.groupObj.length > 0) {
                  me.isEmpty = false
                } else {
                  me.isEmpty = true
                }
                me.isShowLoading = false
              }).catch((err) => {
                this.$log.error(err)
                clearInterval(this.groupInterval)
                this.isShowLoading = false
              })
          }
        } catch (error) {
          me.$log.error(error)
          clearInterval(this.groupInterval)
          this.isShowLoading = false
        }
      }, this.intervalTime)
      me.getIGMPStatistics()
        .then(res => {
          me.statusObj = res.result
        }).catch((err) => {
          this.$log.error(err)
          clearInterval(this.groupInterval)
          this.isShowLoading = false
        })
      me.getIGMPgroups()
        .then(res => {
          me.groupObj = res.result
          if (me.groupObj && me.groupObj.length > 0) {
            me.isEmpty = false
          } else {
            me.isEmpty = true
          }
          me.isShowLoading = false
        }).catch((err) => {
          this.$log.error(err)
          clearInterval(this.groupInterval)
          this.isShowLoading = false
        })
    },
    getOdd: function (number) {
      if (number % 2 === 0) {
        return false
      } else {
        return true
      }
    },
    getPortMembers: function (members, number) {
      if (members.length > 0) {
        let index = members.indexOf('' + number)
        if (index > -1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.module.currentUser,
      portNumber: state => state.module.portNum,
      showFullLoading: state => state.module.showFullLoading,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>

<style lang="scss" scoped>

.igmp-statistic {
  position: relative;
  padding: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    .scrollbar-body {
      height: 100%;
    }
    .content-item {
      >.content-body-header {
        margin-bottom: 10px;
        user-select: none;
      }
      &:last-child {
        padding-top: 0px !important;
        margin-bottom: 0px !important;
      }
    }
  }
  .content-item.status {
    border: 1px solid #f1f1f1;
    border-radius: 12px;
    margin-bottom: 10px;
    >.title, >.table-row {
      padding: 10px 20px;
    }
    >.title >span {
      margin-left: 5px;
    }
    >.table-row {
      margin: 0px 30px;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
  .table-row {
    >tr {
      >td {
        width: 220px;
        height: 42px;
        padding: 10px 15px;
        >.title, >.value {
          border-right: 1px solid #F1F1F1;
        }
        &:last-child {
          >.title, >.value {
            border-right: none;
          }
        }
      }
    }
  }
  .group-table {
    height: calc(100% - 30px);
    .link-row {
      >.right {
        >.data {
          &.isOdd {
            background: #F1F1F1;
          }
          &.action {
            >.content-item {
              display: inline-block;
              >div {
                display: inline-block;
              }
              &.right {
                float: right;
                padding-right: 20px;
              }
            }
          }
          &.group-id {
            text-align: center;
          }
          &.portNo {
              padding: 0px !important;
              border-right: #F1F1F1;
              .q-icon {
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin: 9px auto;
                fill: #000000;
              }
            }
        }
      }
    }
    .qweb-column.portNo {
      padding: 0px;
      text-align: center;
    }
  }
  .content-item.empty {
    text-align: center;
    svg {
      width: 150px;
      height: 150px;
    }
    div {
      font-family: 'Roboto-M' !important;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IgmpStatistic.vue